import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import pt from 'vuetify/src/locale/pt';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fortawesome/fontawesome-free/css/all.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // cores id visual: #bc290a #f8c1a1 #822312 #341d6f #3c3c3c
        coletivo_nascer: '#ffcb03',
        // primary: '',
        // secondary: '',
        // accent: '',
        // error: '',
        // info: '',
        // success: '',
        // warning: '',
      },
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
  icons: {
    iconfont: 'fa',
  },
});
